import React from 'react';
import { translate } from 'components/Translation';
import { makeStyles } from '@material-ui/styles';
import classNames from 'classnames';
import Refresh from '@material-ui/icons/Refresh';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/topupStyle';
import Card from 'components/Card/Card';
import CustomButton from 'components/CustomButtons/Button';
import CustomInput from 'components/CustomInput/CustomInput';
import { BodyM } from 'components/Typography/Typography';

// @ts-ignore
const useStyles = makeStyles(styles);

interface EditCellProps {
	setTemporaryValue: (value: string) => void;
	resetTemporaryValue: () => void;
	setValue: (value: string) => void;
	temporaryValue: string;
	closeEdit: () => void;
}

const Index = (props: EditCellProps) => {
	const classes = useStyles();
	return (
		<div style={{ position: 'relative', width: '100%' }} id="single-topup-value">
			<Card className={classes.editValue} raised>
				<div>
					<CustomButton
						justIcon
						color="tertiary-light"
						id="refresh-value"
						className={classNames(classes.editIcon, classes.editCellIcon)}
						onClick={() => props.resetTemporaryValue()}
					>
						<Refresh />
					</CustomButton>
				</div>
				<div className={classes.editCellInputWrapper}>
					<CustomInput
						inputProps={{
							value: props.temporaryValue,
							onChange: (event: React.FormEvent<HTMLFormElement>) => {
								const value = (event.target as HTMLFormElement).value;
								props.setTemporaryValue(value);
							},
						}}
						formControlProps={{
							className: classNames(classes.customInput, classes.editInput),
						}}
						variant="outlined"
					/>
					<BodyM disableMargin>{translate('OMR')}</BodyM>
				</div>
				<div className={classes.editButtons}>
					<div>
						<CustomButton color="tertiary-light" onClick={() => props.closeEdit()}>
							{translate('payments.topup.cancel')}
						</CustomButton>
					</div>
					<div>
						<CustomButton
							color="primary-light"
							id="set-topup-value"
							onClick={() => props.setValue(props.temporaryValue)}
						>
							{translate('payments.topup.set')}
						</CustomButton>
					</div>
				</div>
			</Card>
		</div>
	);
};

export default Index;
